import { Box, Text, BoxProps } from "@chakra-ui/react";
import ClaimHyperlink from "../DetailElement/Elements/ClaimHyperlink";
import { FunctionComponent, ReactElement } from "react";

export interface DataItem {
	title: string;
	isurl?: boolean;
	url?: string;
	value: string;
	childElements?: ReactElement;
}

interface DataCardDisplayProps {
	data: DataItem[];
	leftSideRows?: number;
	rightSideRows?: number;
	style?: BoxProps;
	leftLabelMinWidth?: number;
	rightLabelMinWidth?: number;
}

const DataCardDisplay: FunctionComponent<DataCardDisplayProps> = (props: DataCardDisplayProps): ReactElement => {
	const {
		data,
		leftSideRows = 4,
		rightSideRows = 2,
		style = {},
		leftLabelMinWidth = 10,
		rightLabelMinWidth = 10
	} = props;
	return (
		<Box bg="offWhite" borderRadius="5px" px={4} py={2} {...style}>
			<Box display="grid" gridTemplateColumns="1fr 1fr" gap="16px">
				{/* Left Column */}
				<Box>
					{data.slice(0, leftSideRows).map((item: DataItem, index: number) => (
						<Box key={index} mb="4px" display="flex">
							<Text
								color="gray.800"
								fontSize="16px"
								textAlign="left"
								fontWeight="600"
								lineHeight="1.5"
								minW={leftLabelMinWidth}>
								{item.title}:
							</Text>
							{item.isurl && item.url ? (
								<>
									<ClaimHyperlink linkHref={item.url} linkText={item.value} />
									{item.childElements}
								</>
							) : (
								<Text color="gray.800" fontSize="16px" fontWeight="400" lineHeight="1.5" ml="4px">
									{item.value} {item.childElements}
								</Text>
							)}
						</Box>
					))}
				</Box>

				{/* Right Column */}
				<Box>
					{data.slice(leftSideRows, data.length).map((item: DataItem, index: number) => (
						<Box key={index} mb="4px" display="flex">
							<Text
								textAlign="left"
								color="gray.800"
								fontSize="16px"
								fontWeight="600"
								lineHeight="1.5"
								minW={rightLabelMinWidth}>
								{item.title}:
							</Text>
							<Text color="gray.800" fontSize="16px" fontWeight="400" lineHeight="1.5" ml="4px">
								{item.value} {item.childElements}
							</Text>
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	);
};

export default DataCardDisplay;
